// src/api/listsApi.js
import { getAuthHeaders } from './authApi';
import { API_BASE_URL } from '../config/apiConfig';
import { parseApiResponse } from './apiResponse';

const listsApi = {
  fetchLists: async () => {
    const response = await fetch(`${API_BASE_URL}list-list.php`, {
      headers: getAuthHeaders(),
    });

    return parseApiResponse(response);
  },

  createList: async (name) => {
    const response = await fetch(`${API_BASE_URL}list-insert.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ name }),
    });

    return parseApiResponse(response);
  },

  updateList: async (id, name) => {
    const response = await fetch(`${API_BASE_URL}list-edit.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id, name }),
    });

    return parseApiResponse(response);
  },

  deleteList: async (id) => {
    const response = await fetch(`${API_BASE_URL}list-delete.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id }),
    });

    return parseApiResponse(response);
  },
};

export { listsApi };
